// ---------------------------------------------------------------------------
// WelcomeScreen — first-load decision screen (Enable / Skip)
// ---------------------------------------------------------------------------

interface WelcomeScreenProps {
  onEnable: () => void;
  onSkip: () => void;
}

export function WelcomeScreen({ onEnable, onSkip }: WelcomeScreenProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--color-bg)] px-4">
      <div className="w-full max-w-md rounded-xl border border-border bg-surface p-8 shadow-lg">
        <div className="mb-6 flex items-center justify-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary text-white">
            <svg
              className="h-7 w-7"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
              />
            </svg>
          </div>
        </div>

        <h1 className="mb-2 text-center text-xl font-bold text-[var(--color-text)]">
          Protect your data
        </h1>
        <p className="mb-6 text-center text-sm text-[var(--color-text-secondary)]">
          GPA Scales stores student names, grades, and GPA data on this device. Enable
          App Lock to encrypt this data with a password so it stays private.
        </p>

        <ul className="mb-6 space-y-2 text-xs text-[var(--color-text-muted)]">
          <li className="flex items-start gap-2">
            <span className="mt-0.5 text-primary">&#10003;</span>
            <span>AES-256 encryption of all stored data</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="mt-0.5 text-primary">&#10003;</span>
            <span>Automatic lock after inactivity</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="mt-0.5 text-primary">&#10003;</span>
            <span>Runs entirely on this device — nothing is uploaded</span>
          </li>
        </ul>

        <div className="flex flex-col gap-2">
          <button
            onClick={onEnable}
            className="w-full rounded-md bg-primary px-4 py-2.5 text-sm font-semibold text-white transition-[var(--transition-fast)] hover:bg-primary-hover"
          >
            Enable App Lock
          </button>
          <button
            onClick={onSkip}
            className="w-full rounded-md border border-border px-4 py-2.5 text-sm font-medium text-[var(--color-text-secondary)] transition-[var(--transition-fast)] hover:bg-[var(--color-bg-tertiary)]"
          >
            Skip
          </button>
        </div>
      </div>
    </div>
  );
}
